import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import PublishingSuggestionSetting from './publishing-suggestion-setting.dialog'
import ArticleTypeSetting from './article-type-setting.dialog'
import Add from './add.dialog'
import { settingJournalAtype } from '@/api/setting'

const columns = [
  {
    title: '',
    enTitle: 'Article Type Name',
    width: 200,
    dataIndex: 'atype',
    slot: 'countryName'
  },
  {
    title: '',
    enTitle: 'Other Name',
    width: 200,
    dataIndex: 'atype',
    slot: 'otherName'
  },
  {
    title: '',
    enTitle: 'Publishing Suggestion',
    width: 180,
    dataIndex: 'publishSuggestion',
    slot: 'publishSuggestion'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 120,
    dataIndex: 'released',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 200,
    dataIndex: 'operator',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Operator Email',
    width: 200,
    dataIndex: 'operator',
    slot: 'email'
  },
  {
    title: '',
    enTitle: 'Operation Time',
    width: 150,
    dataIndex: 'updateTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    SiteSearchGroup,
    PublishingSuggestionSetting,
    ArticleTypeSetting,
    Add
  },
  data() {
    return {
      columns,
      publishSuggestions: {
        ENCOURAGE: 'Encourage',
        SUPPORT: 'Support',
        NOT_RECOMMENDED: 'Not Recommended'
      },
      params: {
        released: '',
        publishSuggestion: '',
        keyword: ''
      },
      inputData: {},
      dataSource: [],
      articleTypeVisable: false,
      publishingSuggestionVisable: false,
      addVisable: false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      journalId: 'getJournalId',
      user: 'getUser'
    })
  },
  watch: {
    journalId: {
      handler() {
        this.getList()
      },
      immediate: true
    }
  },
  methods: {
    async getList() {
      if (!this.journalId) {
        return
      }
      const data = Object.assign(this.params, {
        journalId: this.journalId
      })

      this.dataSource = await settingJournalAtype.getAll(data)
    },
    changeStatus(status) {
      this.params.released = status
      this.getList()
    },
    edit(val) {
      this.inputData = val
      this.addVisable = true
    },
    handlerSetting(val) {
      this[val + 'Visable'] = true
    },
    confirm() {
      this.articleTypeVisable = false
      this.publishingSuggestionVisable = false
      this.addVisable = false
      this.getList()
    },
    cancel() {
      this.articleTypeVisable = false
      this.publishingSuggestionVisable = false
      this.addVisable = false
    },
    async setSort(val) {
      const data = []
      val.forEach((item, index) => {
        if (item.sort !== index) {
          item.sort = index
          data.push(item)
        }
      })
      await settingJournalAtype.setSort(data)
      this.getList()
    },
    async able(val) {
      const { id, released, version } = val
      await settingJournalAtype.release(id, !released, { version })
      let content = 'This Article Type has been published!'
      if (released) {
        content = 'This Article Type has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    },
    handleClear() {
      this.params = {
        publishSuggestion: '',
        keyword: ''
      }
      this.getList()
    }
  }
}
